module.exports = __webpack_public_path__ + "static/media/cloud.2a5dc002.svg";